import React from 'react'

const FeedLeaderBoardListItemLoader = () => (
  <div className="loader leader-board-list-item-loader">
    <div
      className="loader-row"
      style={{
        width: 16,
        height: 14,
      }}
    />
    <div
      className="loader-row"
      style={{
        borderRadius: '50%',
        width: 22,
        height: 22,
        marginLeft: 16,
        marginRight: 17,
      }}
    />
    <div
      className="loader-row"
      style={{
        width: '60%',
        height: 14,
      }}
    />
    <div
      className="loader-row"
      style={{
        width: 16,
        height: 14,
        marginLeft: 'auto',
      }}
    />
  </div>
)

FeedLeaderBoardListItemLoader.displayName = 'FeedLeaderBoardListItemLoader'

export default FeedLeaderBoardListItemLoader
